<dialog #dialogElement (cancel)="onDialogCancel($event)">
  <div class="overlay-window" [ngClass]="[(animInState ? 'anim-in': ''), 'overlay-window--theme-' + theme]">
    <div class="overlay-window__window-content" #windowContentEl>
      <div class="overlay-window__window-inner-content">
        <div class="overlay-window__header">


          <brt-overlay-window-header [title]="componentData.title ?? ''" [bottomLine]="componentData.headerBottomLine ?? true" [noBackdropFilter]="componentData.headerNoBackdropFilter ?? false" (onClosed)="onHeaderClosedEmitted($event)">
            <ng-template #headerEl *ngIf="componentData.componentHeader"></ng-template>
          </brt-overlay-window-header>
        </div>

        <div class="overlay-window__content">
          <ng-template #contentEl>
            <!--    <brt-overlay-window-content></brt-overlay-window-content>-->
          </ng-template>
        </div>


        <div class="overlay-window__footer" *ngIf="this.componentData.componentFooter">
          <ng-template #footerEl></ng-template>
        </div>
      </div>
    </div>
  </div>
</dialog>

